define.alias("shared/components/shared/ui/calculating-state", "media/components/shared/ui/calculating-state");